module.exports = __webpack_public_path__ + "img/avatar_ico4.4c2ad0fb.jpg";